module.exports = "/_next/static/images/oscola-reference-list-03dc8cd5efd26d7a70e8885ecb87a6aa.png";